import React, { useState, useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import * as api from "../../../actions/api";
import RoleFormData from "./RoleFormData";
import encryptionService from "../../../services/encryptionService";

const Addrole = (props) => {

  //get DispensingLanguage
  const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
  const lan = localStorage.getItem('LangCode');
  const menukey = "role-entry";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo==0?'': UserInfo[0].name;


  const [formData, setFormData] = useState({
    role: "",
    defaultredirect:"",
    bFacilitySelected: false,
    IsAllFacility: false,
    IsAllowOrderComplete: false,
    ItemGroupId: "",
    multiselectItemGroup: "",
    ItemGroupIds: [],
  });
  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  useQuery(
    ["role", id],
    () =>
      api.geRoles(id).then((res) => {
        setFormData(res.data);
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { isLoading, mutate } = useMutation(api.saveRole, {
    onSuccess: (data) => {

      if(data.status==200) {
  
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
  
        queryClient.getQueriesData("roles");//api page name
        props.history.push("/role-entry");//
  
      }else{
  
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
       
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    console.log("formData: ", formData);
    data[name] = value;

    setFormData(data);

    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      role: "",
      defaultredirect:"",
      bFacilitySelected: false,
      IsAllFacility: false,
      IsAllowOrderComplete: false,
      ItemGroupId: "",
      multiselectItemGroup: "",
      ItemGroupIds: [],
      
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["role"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = (DispensingLanguage[lan][menukey]['field is Required !']);
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleSubmit = async (e) => {
    if (!formData.multiselectItemGroup || formData.multiselectItemGroup.length === 0) {
      props.openNoticeModal({
        isOpen: true,
        msg: (DispensingLanguage[lan][menukey]['Select a Product Group.']),
        msgtype: 0,
      });
      return;
    }

    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
      mutate(fDtat);
     // swal("Success!", "", "success");
    }
  };

  return (
    <>
      <RoleFormData
        errorObject={errorObject}
        addProductForm={true}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleSubmit={handleSubmit}
        {...props}
      />
    </>
  );
};

export default Addrole;

